<template>
    <div>
        <v-container fluid>
            <v-card elevation="10">
                <v-card-subtitle>
                    {{aviso.aviso_fin}}
                    <v-spacer></v-spacer>
                </v-card-subtitle>
                <v-card-text>
                    <v-row justify="space-around">
                        <v-switch v-model="pred" inset :label="pred ? 'Personalizado':'Predeterminado'" class="mx-2"></v-switch>
                        <v-col cols="12" align="center" v-if="pred">
                            <image-input v-model="avatar">
                                <div slot="activator">  
                                <v-avatar size="100" v-if="!avatarTmp" class="grey lighten-3 mb-3">
                                    <span>Agregar Imagen</span>
                                </v-avatar>                            
                                    <v-img v-else :src="avatarTmp" alt="Avatar de Usuario" height="100px" width="100px"> </v-img>
                                </div>
                            </image-input>
                        </v-col>
                        <v-col cols="12" v-if="pred">
                            <v-text-field v-model="aviso.titulo_fin" label="Titulo" required outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" v-if="pred">
                            <v-textarea v-model="aviso.mensaje_fin" outlined label="Mensaje" rows="2"></v-textarea>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" v-if="salvar" @click="presave(aviso)">Guardar Cambios</v-btn>
                </v-card-actions>
            </v-card>
        </v-container>
    </div>
</template>
<script>
import ImageInput from '../components/ImageInput'
import axios from "axios"
import store from "../store"
import swal from 'sweetalert'
import api from '../conf/ruta-base'
export default {
    name: 'aviso',
    components:{ImageInput},
    props:{
        aviso: {
            type: Object,
            default: null
        },
    },
    data() {
        return {
            avatar: null, avatarTmp: null, chosenFile: null, pred: null, salvar: null,
        }
    },
    watch: {
      avatar(){
        this.avatarTmp = this.avatar.imageURL
        this.chosenFile = this.avatar.imageFile
      },
      pred(){
          if(this.salvar == null){
              this.salvar = false
          }else{
              this.salvar = true
          }
          
      }
    },
    created() {
        this.pred = this.aviso.pred_fin
        if(this.aviso.imagen_fin.length>0){
            this.avatarTmp = this.aviso.imagen_fin
        }
    },
    methods: {
        toast(color, text) {
            var toast = { color, text };
            store.commit("TOAST", toast);
        },

        presave(aviso){
            if(this.pred){
                if(aviso.titulo_fin.length==0 || aviso.mensaje_fin.length==0){
                    swal('','Titulo o Mensaje no valido','error');
                    console.log(aviso)
                }else{
                    this.save(aviso)
                }
            }else{
                axios
                .put(api.api + 'aviso/fin/'+aviso.id)
                    .then(r => {
                        this.toast(r.data.c, r.data.mensaje)
                        this.salvar = false
                    })
            }
        },
        
        save(aviso){
            let img = new FormData()
            let opt = {
                headers: {
                    'Accept': 'application/json','Content-Type': 'multipart/form-data',
                }
            }
            if(this.chosenFile !== null){
                img.append('imagen',this.chosenFile,this.chosenFile.name)
            }
            img.append('id',this.aviso.id)
            img.append('titulo_fin',aviso.titulo_fin)
            img.append('mensaje_fin',aviso.mensaje_fin)
            img.append('api',api.api)
            axios
            .put(api.api + 'aviso/fin', img, opt)
                .then(r => {
                    this.toast(r.data.c, r.data.mensaje)
                    this.salvar = false
                })
            }
        }
}
</script>